import * as types from "../types/index";
import { setInitialState } from "../InitialState";


const INITIAL_STATE = setInitialState({
    data: null,
});


export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.ORGANISATION_CREATE_TAG_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case types.ORGANISATION_CREATE_TAG_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                data: action.payload.success
            };
        case types.ORGANISATION_CREATE_TAG_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                isSuccess: false,
                data: action.payload.response,
            };
        case types.RESET_ORGANISATION_CREATE_TAG:
            return {
                ...state,
                isFetching: false,
                isError: false,
                data: null,
            };
        default:
            return {
                ...state
            }
    }
}